var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.activeText')}},[_c('el-input',{model:{value:(_vm.optionModel.activeText),callback:function ($$v) {_vm.$set(_vm.optionModel, "activeText", $$v)},expression:"optionModel.activeText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }